<template>
  <PageView :no-sub-title-expected="true">
    <TitleView>{{ $t("resetPassword.title") }}</TitleView>

    <ContentView>
      <!-- If reset fails -->
      <b-message v-if="passwordResetError != ''" type="is-danger">
        {{ passwordResetError }}
      </b-message>
      <router-link :to="{ path: '/forgot-password/ ' }">
        <b-button v-if="passwordResetError != ''" type="is-danger">
          <span class="icon is-small"> </span>
          {{ $t("resetPassword.tryagain") }}
        </b-button>
      </router-link>

      <ValidationObserver v-if="passwordResetError == ''" ref="observer" v-slot="{ handleSubmit }">
        <!-- Otherwise, reset form -->
        <b-message type="is-info">
          {{ $t("resetPassword.explain") }}
        </b-message>

        <PasswordCreationWithValidation v-model="password" :label="$t('input-password')" />

        <InputWithValidation
          v-model="confirmation"
          rules="required|confirmed:password"
          type="password"
          password-reveal
          :label="$t('input-password-confirmation')"
        />

        <b-button type="is-success" @click="handleSubmit(submit)">
          <span>{{ $t("resetPassword.submit") }} </span>
        </b-button>
      </ValidationObserver>
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TitleView from "@/views/commons/TitleView.vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import PasswordCreationWithValidation from "@/views/inputs/PasswordCreationWithValidation.vue"
import { LoginService } from "@/services/rest/login/LoginService"
import { PasswordResetDTO } from "@/model/bean/GeneratedDTOs"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { BButton, BMessage } from "buefy"

export default defineComponent({
  name: "ResetPasswordPage",
  components: {
    TitleView,
    PageView,
    ContentView,
    InputWithValidation,
    ValidationObserver,
    PasswordCreationWithValidation,
    BButton,
    BMessage,
  },
  props: {
    token: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      passwordResetError: "",
      password: "",
      confirmation: "",
      loginService: LoginService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,
    }
  },
  methods: {
    submit(): void {
      const passwordReset = new PasswordResetDTO()
      passwordReset.motDePasse = this.password
      passwordReset.confirmationMotDePasse = this.confirmation
      this.loginService.resetPassword(this.token, passwordReset).then(
        (_success) => {
          // Nothing to do: user already re-routed after succesfull login (see LoginService.loginSucceeded())
        },
        (_reject) => {
          this.passwordResetError = this.$t("resetPassword.error").toString()
        },
      )
    },
  },
})
</script>
